module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-stone-path.5e3f4cf5.png";